export default function getUserInfoData(produit, produitEnfant) {
  if (!produit) return {};

  const info = {
    creatorUserId: produit.creatorUserId,
    creationTime: produit.creationTime,
    lastModifierUserId: produit.lastModifierUserId,
    lastModificationTime: produit.lastModificationTime,
  };

  const enfantTime = produitEnfant?.lastModificationTime;
  const produitTime = info.lastModificationTime;

  if (!produitTime || (enfantTime && new Date(enfantTime) > new Date(produitTime))) {
    info.lastModifierUserId = produitEnfant?.lastModifierUserId;
    info.lastModificationTime = enfantTime;
  }

  return info;
}
